export const setSelectedFarms = (selectedFarms) => {
  return {
    type: 'setSelectedFarms',
    selectedFarms,
  };
};
